(function () {
  function initStoreMobileNav() {
    const toggle = document.querySelector('.tr-shop-mobile-toggle');
    const menu = document.querySelector('#tr-shop-mobile-menu');

    if (!toggle || !menu || toggle.dataset.mobileNavBound === 'true') {
      return;
    }

    toggle.dataset.mobileNavBound = 'true';

    toggle.addEventListener('click', function () {
      const isOpen = document.body.classList.toggle('tr-shop-menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      document.body.classList.remove('tr-shop-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', initStoreMobileNav);
  document.addEventListener('shopify:section:load', initStoreMobileNav);
})();